import React, { useState } from "react";
import { PlusIcon, MinusIcon } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return <div className="border border-neutral-800 rounded-xl bg-neutral-950 overflow-hidden" data-id="element-23" data-mp="1r03435nsjlk9">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-24" data-mp="1d0k6h6slvsm7">
        <span className="font-condensed text-xl text-white tracking-wide" data-id="element-25" data-mp="1335rzcq8tdwj">{question}</span>
        <span className="flex-shrink-0 text-[#e10600]" data-id="element-26" data-mp="181z9dg8nhp1z">
          {open ? <MinusIcon className="w-6 h-6" data-id="element-27" data-mp="1828zd3tp3w7o" /> : <PlusIcon className="w-6 h-6" data-id="element-28" data-mp="2xgx90xawj020" />}
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-29" data-mp="2xhqcnpekd9fx">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-30" data-mp="32eyt9lk2d5f2">
            <p className="px-5 pb-5 text-neutral-400 leading-relaxed" data-id="element-31" data-mp="v2rvh999l3qj">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}